import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Form, Formik } from 'formik';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { usePostData } from '../hooks/use-post-data.hook';
import {
    FormikBttonsComponent,
    SubmitActionType,
    SUBMIT_ACTION_TYPE_KEY_NAME,
} from './formik-buttons.component';
import { LoadingIndicator } from './loading-indicator.component';
import { API_END_POINT } from '../constants';


interface FormikModelDialogProps {
    children: ReactNode;
    customButtons?: ReactElement<any>;
    show: boolean;
    title: string | ReactElement<any>;
    footer?: ReactElement<any>;
    initialData: any;
    validate?: any;
    validationSchema?: any;
    endpoint: API_END_POINT,
    postRoute: string;
    onClose?: (status: SubmitStatus, data: any) => any;
    postDataFormatter?: (data: any) => any;
    showAddAnother?: boolean;
    width?: string;
    isUpDateEntityDetails?: boolean;
    isViewOnly?: boolean
    // onSubmit?: (values: any, helpers: { setSubmitting: (isSubmitting: boolean) => void }) => void; // Add this line
}

export enum SubmitStatus {
    Completed,
    CompletedAddNew,
    Cancel,
}

export const FormikModelDialog = ({
    children,
    customButtons,
    title,
    footer,
    show,
    initialData,
    isUpDateEntityDetails = false,
    width = "95%",
    validate,
    validationSchema,
    endpoint,
    postRoute,
    onClose,
    postDataFormatter,
    showAddAnother,
    isViewOnly
    
}: FormikModelDialogProps) => {
    const {
        submitData,
        response: { isSubmitting, result, error, submitActionType },
    } = usePostData<any>(endpoint, postRoute, 'POST');

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [formDirty, setFormDirty] = useState(false);

    useEffect(() => {
        if (!isSubmitting && result!==undefined && !error) {
            if (submitActionType === SubmitActionType.SAVE_AND_CLOSE) {
                onClose(SubmitStatus.Completed, result);
            }
            else {
                onClose(SubmitStatus.CompletedAddNew, result);
            }
        }
    }, [result, isSubmitting]);
    //initialData
    const handleSubmit = async (updatedData: any) => {

        const submitActionType = updatedData[SUBMIT_ACTION_TYPE_KEY_NAME];
        delete updatedData[SUBMIT_ACTION_TYPE_KEY_NAME];
        const postData = postDataFormatter ? postDataFormatter(updatedData) : { ...updatedData };
        
        if (isUpDateEntityDetails) {
            return await submitData({ endPoint: endpoint,  data: updatedData, submitActionType });
        }
        else {
            console.log(postData)
            return submitData({ endPoint: endpoint,data: postData, submitActionType });
        }
    };

    const handleClose = (event: any) => {

        if (event.preventDefault === undefined) {
            if (formDirty) {

                setShowConfirmation(true);
            } else {

                onClose(SubmitStatus.Cancel, null);
            }
        }
        else {
            event.preventDefault();
            onClose(SubmitStatus.Cancel, null);
        }
    };

    const handleConfirmationClose = (confirm: boolean) => {
        setShowConfirmation(false);
        if (confirm) {
            onClose(SubmitStatus.Cancel, null);
        }
    };

    return (
        <>
            {show && (
                <Dialog title={title} onClose={(e: any) => handleClose(e)} width={width} style={{ zIndex: 100 }}>
                    <div>
                        <Formik
                            validateOnMount
                            initialValues={initialData}
                            validate={validate}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(false);
                                handleSubmit(values);
                            }}
                            enableReinitialize
                        >
                            {({ dirty, handleSubmit }) => {
                                setFormDirty(dirty);
                                return (
                                    <Form
                                        onSubmit={(event) => {
                                            event.preventDefault();
                                            handleSubmit();
                                        }}
                                    >
                                        <LoadingIndicator isLoading={isSubmitting} />
                                        {error && <div>Error</div>}
                                        {children}
                                        <DialogActionsBar>
                                            <FormikBttonsComponent
                                                isUpdate={isUpDateEntityDetails}
                                                isViewOnly={isViewOnly}
                                                customButtons={customButtons}
                                                showAddAnother={showAddAnother && !isUpDateEntityDetails}
                                                onClose={(e: any) => handleClose(e)}
                                            />
                                        </DialogActionsBar>
                                    </Form>
                                );
                            }}
                        </Formik>
                        {footer}
                    </div>
                </Dialog>
            )}

            {showConfirmation && (
                <Dialog title="Alert Changes" className="delete-dialog" onClose={() => handleConfirmationClose(false)}>
                    <p>Are you sure you want to cancel the changes?</p>
                    <DialogActionsBar>
                        <div className="d-flex margin-fix p-3">
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => handleConfirmationClose(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary ms-auto btn-sm"
                                onClick={() => handleConfirmationClose(true)}
                            >
                                Ok
                            </button>
                        </div>
                    </DialogActionsBar>
                </Dialog>
            )}
        </>
    );
};
